import React from "react"
import { useContext } from 'react'
import { Link } from 'react-router-dom'
import DodoneContext from 'app/dodones/Context'

export default () => {
  const { dodone } = useContext(DodoneContext);
  return <h1><div> { dodone.id } </div>Miau</h1>
};
